import { FormInputType } from './FormInputType'
import { FormMask } from './FormMask'

export interface FormInputRegion {
  address: string | null
  block: string | null
  city: string | null
  cityKladrId: string | null
  cityText: string | null
  district: string | null
  excludeError: boolean
  flat: string | null
  flatType: string | null
  house: string | null
  houseType: string | null
  // eslint-disable-next-line camelcase
  kladr_id: string | null
  postalCode: string | null
  region: string | null
  regionId: number | null
  regionText: string | null
  regionWithType: string | null
  // eslint-disable-next-line camelcase
  region_kladr_id: string | null
  // eslint-disable-next-line camelcase
  settlement_kladr_id: string | null
  street: string | null
  streetWithType: string | null
}

export interface SelectOption<T = string> {
  readonly name: string
  readonly value: T
}

export interface FormInputBasic {
  readonly id: string
  readonly type: FormInputType
  readonly label: string
  readonly placeholder: string
  readonly error: boolean | string
  readonly rules: ReadonlyArray<string>
  readonly mask?: typeof FormMask[keyof typeof FormMask]
  readonly initialValue?: string | boolean
  readonly valueForm?: string | boolean
}

export interface FormInputText extends FormInputBasic {
  readonly value: string
  readonly maxlength?: number | undefined
  readonly withUpperCase?: boolean
  readonly withCapitalise?: boolean
  readonly formModel?: any
}

export interface FormInputSelect extends FormInputBasic {
  readonly selectOptions: ReadonlyArray<SelectOption>
  readonly noResultText: string
  readonly useBorder?: boolean
}

export const emptyFormInputText = (): FormInputText => {
  return {
    id: '',
    label: '',
    type: FormInputType.Text,
    placeholder: '',
    error: '',
    rules: [],
    mask: FormMask.NotSet,
    value: '',
  }
}
